import { NotificationKey } from 'interfaces';

export enum NotificationCategory {
  ACCESS_AUTH = 'access_and_auth',
  INVITATIONS = 'invite',
  ACCESS_MANAGEMENT = 'room_access_management',
  DOCUMENTS_UPLOAD = 'upload_document',
  DOCUMENTS_DELETE = 'delete_document',
  DOCUMENTS_ACTIONS = 'actions_with_documents',
  AGREEMENTS = 'document_agreement',
  SIGNING = 'document_signing',
  NDA = 'nda_actions',
  ORGANIZATIONS = 'organizations',
  ADMINISTRATIVE = 'administrative_notification',
  CREATE_DOCUMENT = 'create_document',
  NEW_NDA_VERSION = 'new_nda_version',
}

export const NOTIFICATION_CATEGORY_LABEL_KEY_MAP: Record<NotificationCategory, string> = {
  [NotificationCategory.ACCESS_AUTH]: 'notificationsSettings.categories.access_auth',
  [NotificationCategory.INVITATIONS]: 'notificationsSettings.categories.invitations',
  [NotificationCategory.ACCESS_MANAGEMENT]: 'notificationsSettings.categories.access_management',
  [NotificationCategory.DOCUMENTS_UPLOAD]: 'notificationsSettings.categories.documents_upload',
  [NotificationCategory.DOCUMENTS_DELETE]: 'notificationsSettings.categories.documents_delete',
  [NotificationCategory.DOCUMENTS_ACTIONS]: 'notificationsSettings.categories.documents_actions',
  [NotificationCategory.AGREEMENTS]: 'notificationsSettings.categories.agreements',
  [NotificationCategory.SIGNING]: 'notificationsSettings.categories.signing',
  [NotificationCategory.NDA]: 'notificationsSettings.categories.nda',
  [NotificationCategory.ORGANIZATIONS]: 'notificationsSettings.categories.organizations',
  [NotificationCategory.ADMINISTRATIVE]: 'notificationsSettings.categories.administrative',
  [NotificationCategory.CREATE_DOCUMENT]: 'notificationsSettings.categories.create_document',
  [NotificationCategory.NEW_NDA_VERSION]: 'notificationsSettings.categories.new_nda_version',
};

export const NOTIFICATION_LABEL_KEY_MAP: Record<NotificationKey, string> = {
  REGISTER: 'notificationsSettings.keys.REGISTER',
  AUTH_USER: 'notificationsSettings.keys.AUTH_USER',
  RESTORE_PASSWORD: 'notificationsSettings.keys.RESTORE_PASSWORD',
  PIN_CODE_RESTORE: 'notificationsSettings.keys.PIN_CODE_RESTORE',
  DOCUMENT_SINGING: 'notificationsSettings.keys.DOCUMENT_SINGING',
  INVITE_USER: 'notificationsSettings.keys.INVITE_USER',
  INVITE_USER_TO_ORGANIZATION: 'notificationsSettings.keys.INVITE_USER_TO_ORGANIZATION',
  INVITE_REFRESH: 'notificationsSettings.keys.INVITE_REFRESH',
  INVITE_REMINDER: 'notificationsSettings.keys.INVITE_REMINDER',
  KICK_USER: 'notificationsSettings.keys.KICK_USER',
  BLOCK_USER_BY_ROOM: 'notificationsSettings.keys.BLOCK_USER_BY_ROOM',
  UNBLOCK_USER_BY_ROOM: 'notificationsSettings.keys.UNBLOCK_USER_BY_ROOM',
  UPDATE_PERMISSIONS: 'notificationsSettings.keys.UPDATE_PERMISSIONS',
  UPDATE_ROLE: 'notificationsSettings.keys.UPDATE_ROLE',
  UPLOAD_DOCUMENT: 'notificationsSettings.keys.UPLOAD_DOCUMENT',
  UPLOAD_DOCUMENT_CONFIDENTIAL: 'notificationsSettings.keys.UPLOAD_DOCUMENT_CONFIDENTIAL',
  UPLOAD_DOCUMENT_VERSION: 'notificationsSettings.keys.UPLOAD_DOCUMENT_VERSION',
  UPLOAD_DOCUMENT_VERSION_CONFIDENTIAL: 'notificationsSettings.keys.UPLOAD_DOCUMENT_VERSION_CONFIDENTIAL',
  DELETE_FILE: 'notificationsSettings.keys.DELETE_FILE',
  DELETE_FILE_CONFIDENTIAL: 'notificationsSettings.keys.DELETE_FILE_CONFIDENTIAL',
  DELETE_VIDEO: 'notificationsSettings.keys.DELETE_VIDEO',
  DELETE_VIDEO_CONFIDENTIAL: 'notificationsSettings.keys.DELETE_VIDEO_CONFIDENTIAL',
  SHARE_DOCUMENT: 'notificationsSettings.keys.SHARE_DOCUMENT',
  OPEN_FILE: 'notificationsSettings.keys.OPEN_FILE',
  OPEN_FILE_CONFIDENT: 'notificationsSettings.keys.OPEN_FILE_CONFIDENT',
  VIEW_FILE: 'notificationsSettings.keys.VIEW_FILE',
  VIEW_FILE_CONFIDENTIAL: 'notificationsSettings.keys.VIEW_FILE_CONFIDENTIAL',
  VIEW_FILE_ORGANIZATION: 'notificationsSettings.keys.VIEW_FILE_ORGANIZATION',
  DOWNLOAD_FILE: 'notificationsSettings.keys.DOWNLOAD_FILE',
  DOWNLOAD_FILE_CONFIDENTIAL: 'notificationsSettings.keys.DOWNLOAD_FILE_CONFIDENTIAL',
  DOWNLOAD_FILE_ORGANIZATION: 'notificationsSettings.keys.DOWNLOAD_FILE_ORGANIZATION',
  DOWNLOAD_FILE_AS_PDF: 'notificationsSettings.keys.DOWNLOAD_FILE_AS_PDF',
  DOWNLOAD_CONF_FILE_AS_PDF: 'notificationsSettings.keys.DOWNLOAD_CONF_FILE_AS_PDF',
  INIT_AGREEMENT: 'notificationsSettings.keys.INIT_AGREEMENT',
  UPDATE_AGREEMENT: 'notificationsSettings.keys.UPDATE_AGREEMENT',
  DECLINE_AGREEMENT: 'notificationsSettings.keys.DECLINE_AGREEMENT',
  DELETE_AGREEMENT: 'notificationsSettings.keys.DELETE_AGREEMENT',
  FINALIZE_AGREEMENT: 'notificationsSettings.keys.FINALIZE_AGREEMENT',
  SIGNING_INIT: 'notificationsSettings.keys.SIGNING_INIT',
  SIGNING_OF_DOCUMENT: 'notificationsSettings.keys.SIGNING_OF_DOCUMENT',
  REJECTION_SIGNING: 'notificationsSettings.keys.REJECTION_SIGNING',
  DELETE_SIGNING: 'notificationsSettings.keys.DELETE_SIGNING',
  FINALIZATION_OF_DOCUMENT_SIGNING: 'notificationsSettings.keys.FINALIZATION_OF_DOCUMENT_SIGNING',
  NDA_SIGNED: 'notificationsSettings.keys.NDA_SIGNED',
  NDA_DECLINED: 'notificationsSettings.keys.NDA_DECLINED',
  NDA_ENABLE: 'notificationsSettings.keys.NDA_ENABLE',
  ADD_PARTY: 'notificationsSettings.keys.ADD_PARTY',
  ADD_ORGANIZATION_TO_ROOM: 'notificationsSettings.keys.ADD_ORGANIZATION_TO_ROOM',
  REMOVE_PARTY: 'notificationsSettings.keys.REMOVE_PARTY',
  DELETE_ROOM: 'notificationsSettings.keys.DELETE_ROOM',
  TARIFF_EXPIRED: 'notificationsSettings.keys.TARIFF_EXPIRED',
  NEW_MESSAGE_IN_CHAT: 'notificationsSettings.keys.NEW_MESSAGE_IN_CHAT',
  INIT_BOOKING: 'notificationsSettings.keys.INIT_BOOKING',
  ORGANIZATION_ROOM_INVITE: 'notificationsSettings.keys.ORGANIZATION_ROOM_INVITE',
  CREATE_DOCUMENT: 'notificationsSettings.keys.CREATE_DOCUMENT',
  NEW_NDA_VERSION: 'notificationsSettings.keys.NEW_NDA_VERSION',
};
